/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Todo controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, UploadTodoDocumentResponse, GetTodoByIdResponse, UpdateTodoRequest, TodoPriorityId, TodoCompletion, TodoState, GetTodosResponse, CreateTodoRequest, CreateTodoResponse, ChangeTodoStatusRequest, ChangeTodoCompletionRequest } from "../models";

@Injectable({ providedIn: "root" })
export class TodoService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    uploadTodoDocument(id: number, file: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<UploadTodoDocumentResponse>;
    uploadTodoDocument(id: number, file: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UploadTodoDocumentResponse>>;
    uploadTodoDocument(id: number, file: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UploadTodoDocumentResponse>>;
    uploadTodoDocument(id: number, file: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}/documents`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, formData, requestOptions);
    }

    getTodoById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTodoByIdResponse>;
    getTodoById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTodoByIdResponse>>;
    getTodoById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTodoByIdResponse>>;
    getTodoById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateTodo(id: number, updateTodoRequest: UpdateTodoRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTodo(id: number, updateTodoRequest: UpdateTodoRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTodo(id: number, updateTodoRequest: UpdateTodoRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTodo(id: number, updateTodoRequest: UpdateTodoRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTodoRequest, requestOptions);
    }

    deleteTodo(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTodo(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTodo(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTodo(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getTodos(searchText?: string | null, createdByIds?: (Array<number> | null), clientIds?: (Array<number> | null), assignedToIds?: (Array<number> | null), priorities?: (Array<TodoPriorityId> | null), completions?: (Array<TodoCompletion> | null), states?: (Array<TodoState> | null), startDueDate?: Date | null, endDueDate?: Date | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTodosResponse>;
    getTodos(searchText?: string | null, createdByIds?: (Array<number> | null), clientIds?: (Array<number> | null), assignedToIds?: (Array<number> | null), priorities?: (Array<TodoPriorityId> | null), completions?: (Array<TodoCompletion> | null), states?: (Array<TodoState> | null), startDueDate?: Date | null, endDueDate?: Date | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTodosResponse>>;
    getTodos(searchText?: string | null, createdByIds?: (Array<number> | null), clientIds?: (Array<number> | null), assignedToIds?: (Array<number> | null), priorities?: (Array<TodoPriorityId> | null), completions?: (Array<TodoCompletion> | null), states?: (Array<TodoState> | null), startDueDate?: Date | null, endDueDate?: Date | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTodosResponse>>;
    getTodos(searchText?: string | null, createdByIds?: (Array<number> | null), clientIds?: (Array<number> | null), assignedToIds?: (Array<number> | null), priorities?: (Array<TodoPriorityId> | null), completions?: (Array<TodoCompletion> | null), states?: (Array<TodoState> | null), startDueDate?: Date | null, endDueDate?: Date | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo`;

        let params = new HttpParams();
        if (searchText != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchText, 'searchText');
        }
        if (createdByIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, createdByIds, 'createdByIds');
        }
        if (clientIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, clientIds, 'clientIds');
        }
        if (assignedToIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, assignedToIds, 'assignedToIds');
        }
        if (priorities != null) {
            params = HttpParamsBuilder.addToHttpParams(params, priorities, 'priorities');
        }
        if (completions != null) {
            params = HttpParamsBuilder.addToHttpParams(params, completions, 'completions');
        }
        if (states != null) {
            params = HttpParamsBuilder.addToHttpParams(params, states, 'states');
        }
        if (startDueDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDueDate, 'startDueDate');
        }
        if (endDueDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDueDate, 'endDueDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createTodo(createTodoRequest: CreateTodoRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateTodoResponse>;
    createTodo(createTodoRequest: CreateTodoRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateTodoResponse>>;
    createTodo(createTodoRequest: CreateTodoRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateTodoResponse>>;
    createTodo(createTodoRequest: CreateTodoRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createTodoRequest, requestOptions);
    }

    deleteTodoDocument(id: number, documentId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTodoDocument(id: number, documentId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTodoDocument(id: number, documentId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTodoDocument(id: number, documentId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}/documents/${documentId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    changeTodoStatus(id: number, changeTodoStatusRequest: ChangeTodoStatusRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    changeTodoStatus(id: number, changeTodoStatusRequest: ChangeTodoStatusRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    changeTodoStatus(id: number, changeTodoStatusRequest: ChangeTodoStatusRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    changeTodoStatus(id: number, changeTodoStatusRequest: ChangeTodoStatusRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}/ChangeStatus`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.patch(url, changeTodoStatusRequest, requestOptions);
    }

    changeTodoCompletion(id: number, changeTodoCompletionRequest: ChangeTodoCompletionRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    changeTodoCompletion(id: number, changeTodoCompletionRequest: ChangeTodoCompletionRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    changeTodoCompletion(id: number, changeTodoCompletionRequest: ChangeTodoCompletionRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    changeTodoCompletion(id: number, changeTodoCompletionRequest: ChangeTodoCompletionRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Todo/${id}/ChangeCompletion`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.patch(url, changeTodoCompletionRequest, requestOptions);
    }
}
